const stats = [
  { value: '50K+', label: 'Happy Customers', icon: 'ri-user-smile-line' },
  { value: '500+', label: 'Restaurants', icon: 'ri-store-3-line' },
  { value: '20+', label: 'Cities', icon: 'ri-map-pin-2-line' },
  { value: '4.8★', label: 'App Rating', icon: 'ri-star-smile-line' },
];

export default function Stats() {
  return (
    <section className="bg-[#009E81] py-8 md:py-10 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-y-6 md:gap-y-0 md:divide-x md:divide-white/20">
        {stats.map((stat, i) => (
          <div
            key={stat.label}
            className={`flex flex-col items-center gap-1 px-4 md:px-8 ${
              i < 2 ? 'border-b border-white/20 pb-6 md:border-b-0 md:pb-0' : 'pt-2 md:pt-0'
            } ${i % 2 === 0 ? 'border-r border-white/20 md:border-r-0' : ''}`}
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`${stat.icon} text-xl md:text-2xl text-white/80`} />
            </div>
            <p className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">{stat.value}</p>
            <p className="text-xs md:text-sm font-medium text-white/70 text-center">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
